import { useEffect, useRef } from "react";
import * as echarts from "echarts";

const DownTimePieChartPercent = ({ active, downTimeData }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;
    if (chartInstanceRef.current) {
      chartInstanceRef.current.dispose();
    }
    const chart = echarts.init(chartRef.current);
    chartInstanceRef.current = chart;
    chart.setOption({
      legend: {
        type: "scroll",
        top: "top",
      },
      // toolbox: {
      //   show: true,
      //   feature: {
      //     mark: { show: true },
      //     dataView: { show: true, readOnly: false },
      //     restore: { show: true },
      //     saveAsImage: { show: true }
      //   }
      // },
      series: [
        {
          name: "Access From",
          type: "pie",
          radius: "75%",
          data: [],
        },
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)",
        },
      },
    });

    const handleResize = () => {
      chart.resize();
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, []);
  useEffect(() => {
    transformDataToPercentage(downTimeData);
  }, []);
  useEffect(() => {
    if (active && chartInstanceRef.current) {
      chartInstanceRef.current.resize();
    }
  }, [active]);

  // const transformDataToPercentage = (data) => {
  //   const siteTotals = {};
  //   data.forEach((entry) => {
  //     const site = entry.Site_Name;
  //     const hours = parseFloat(entry.hours_Down);
  //     siteTotals[site] = (siteTotals[site] || 0) + hours;
  //   });
  //   const totalHours = Object.values(siteTotals).reduce(
  //     (acc, val) => acc + val,
  //     0
  //   );
  //   const seriesData = Object.entries(siteTotals).map(([site, hours]) => ({
  //     name: site,
  //     value: ((hours / totalHours) * 100).toFixed(2), // Convert to percentage
  //   }));
  //   const chart = chartInstanceRef.current;
  //   chart.setOption({
  //     series: [
  //       {
  //         data: seriesData,
  //       },
  //     ],
  //   });
  // };
  const transformDataToPercentage = (data) => {
    const totalsMap = {};

    data.forEach((entry) => {
      const key = `${entry.downCode} - ${entry.downcodeDescription}`;
      const hours = parseFloat(entry.hoursDown);
      totalsMap[key] = (totalsMap[key] || 0) + hours;
    });

    const seriesData = Object.entries(totalsMap).map(([label, hours]) => ({
      name: label,
      value: hours,
    }));

    chartInstanceRef.current.setOption({
      series: [
        {
          type: "pie",
          data: seriesData,
          label: {
            show: true,
            formatter: "{b} - {d}%", // {d}% = percentage auto-calculated by ECharts
          },
        },
      ],
    });
  };

  return (
    <div
      ref={chartRef}
      style={{ width: "100%", height: "100%", minHeight: "675px" }}
    />
  );
};

export default DownTimePieChartPercent;
